import { Caption } from '@remotion/captions';
import React, { useMemo } from 'react';
import { Easing, interpolate } from 'remotion';
import { msToFrame } from './helpers/ms-to-frame';

export const Word: React.FC<{
  readonly item: Caption;
  readonly frame: number;
  readonly transcriptionColor: string;
}> = ({ item, frame, transcriptionColor }) => {
  const opacity = interpolate(
    frame,
    [msToFrame(item.startMs), msToFrame(item.startMs) + 15],
    [0, 1],
    {
      extrapolateLeft: 'clamp',
      extrapolateRight: 'clamp',
    },
  );

  const translateY = interpolate(
    frame,
    [msToFrame(item.startMs), msToFrame(item.startMs) + 10],
    [0.25, 0],
    {
      easing: Easing.out(Easing.quad),
      extrapolateLeft: 'clamp',
      extrapolateRight: 'clamp',
    },
  );

  const style: React.CSSProperties = useMemo(() => {
    return {
      display: 'inline-block',
      whiteSpace: 'pre',
      opacity,
      translate: `0 ${translateY}em`,
      color: transcriptionColor,
    };
  }, [opacity, transcriptionColor, translateY]);

  return <span style={style}>{item.text}</span>;
};
